import { useState } from 'react';
import { useAuthStore } from '../hooks/useAuth';
import Card, { CardHeader } from '../components/common/Card';
import Button from '../components/common/Button';

export default function Settings() {
  const { user, signOut } = useAuthStore();
  const [monthlyBudget, setMonthlyBudget] = useState('50.00');
  const [perVideoBudget, setPerVideoBudget] = useState('5.00');

  return (
    <div className="max-w-2xl space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Settings</h1>
        <p className="text-zinc-400 mt-1">Manage your account and preferences</p>
      </div>

      {/* Account */}
      <Card>
        <CardHeader title="Account" description="Your account information" />
        <div className="space-y-4">
          <div>
            <label className="block text-sm text-zinc-400 mb-1">Email</label>
            <p className="text-lg">{user?.email}</p>
          </div>
          <div>
            <label className="block text-sm text-zinc-400 mb-1">User ID</label>
            <p className="text-sm font-mono text-zinc-500">{user?.id}</p>
          </div>
        </div>
      </Card>

      {/* Budget */}
      <Card>
        <CardHeader title="Budget Limits" description="Control your spending" />
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-2">Monthly Budget ($)</label>
            <input
              type="number"
              value={monthlyBudget}
              onChange={(e) => setMonthlyBudget(e.target.value)}
              className="w-full px-4 py-2 bg-zinc-800 border border-zinc-700 rounded-lg focus:outline-none focus:border-jelly-500"
              min="0"
              step="0.01"
            />
            <p className="text-xs text-zinc-500 mt-1">Maximum spend per month across all personas</p>
          </div>
          <div>
            <label className="block text-sm font-medium mb-2">Per-Video Limit ($)</label>
            <input
              type="number"
              value={perVideoBudget}
              onChange={(e) => setPerVideoBudget(e.target.value)}
              className="w-full px-4 py-2 bg-zinc-800 border border-zinc-700 rounded-lg focus:outline-none focus:border-jelly-500"
              min="0"
              step="0.01"
            />
            <p className="text-xs text-zinc-500 mt-1">Maximum cost for a single video generation</p>
          </div>
          <Button variant="secondary">Save Budget Settings</Button>
        </div>
      </Card>

      {/* API Keys */}
      <Card>
        <CardHeader title="API Keys" description="Manage your API integrations" />
        <div className="space-y-4">
          <div className="p-4 bg-zinc-800 rounded-lg">
            <p className="text-sm text-zinc-400">API key management coming soon.</p>
            <p className="text-sm text-zinc-500 mt-1">
              You'll be able to add your own API keys for video generation services.
            </p>
          </div>
        </div>
      </Card>

      {/* Danger zone */}
      <Card className="border-red-900/50">
        <CardHeader title="Danger Zone" description="Irreversible actions" />
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="font-medium">Sign Out</p>
              <p className="text-sm text-zinc-400">Sign out of your account</p>
            </div>
            <Button variant="danger" onClick={signOut}>
              Sign Out
            </Button>
          </div>
          <div className="border-t border-zinc-800 pt-4 flex items-center justify-between">
            <div>
              <p className="font-medium text-red-400">Delete Account</p>
              <p className="text-sm text-zinc-400">Permanently delete your account and all data</p>
            </div>
            <Button variant="danger" disabled>
              Delete Account
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
}
